import { useNavigate } from "react-router-dom";
import CommonButton from "../../components/ui/CommonButton/CommonButton";
import InputField from "../../components/ui/InputField/InputField";
import classes from "./Login.module.css";
import LoginContainer from "../../components/LoginContainer/LoginContainer";
import LoginCard from "../../components/LoginCard/LoginCard";
import { env } from "../../constants/env";
import { useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isSending, setIsSending] = useState(false);


    const { login } = useAuth();
  
    const handleLogin = async (e) => {
      e.preventDefault();

      setIsSending(true)
  
      try {
        
   const user = await login(email, password)
      //   const { token, user } = response.data;

      //   // Store the token in local storage
      // localStorage.setItem('token', token);

      //   console.log("WHAT DATA", response.data)

        // Redirect if user is admin and canAccessFinancial is true
      // if (user.role === 'admin' && user.accessItems.users) {
      //   navigate('/users');
      // } else if (user.role === 'admin' && user.accessItems.financial) {
      //   navigate('/financial');
      // }else if (user.role === 'admin' && user.accessItems.referrals) {
      //   navigate('/referrals');
      // }else if (user.role === 'admin' && user.accessItems.team) {
      //   navigate('/team');
      // }else if (user.role === 'admin' && user.accessItems.partners) {
      //   navigate('/partner-request');
      // }  else if (user.role === 'superadmin') {
      //   navigate('/'); // Redirect to superadmin dashboard or other page
      // } else {
      //   setErrorMessage('You do not have permission to access the admin panel.');
      // }

      if (user.role === 'admin') {
        navigate('/');
        console.log("USER", user)
      }else {
        setErrorMessage('You do not have permission to access the admin panel.');
      }
  
      } catch (error) {
        setErrorMessage('Invalid credentials or unauthorized access.');
      }
      setIsSending(false)
    };
  return (
    <LoginContainer>
      <LoginCard login={true}>

        <InputField
          labelText="EMAIL"
          className="my-3"
          placeholder="name@email.com"
          type="email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <InputField
          labelText="PASSWORD"
          className="mb-2"
          placeholder="Insert password"
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          showEye={true}
        />
        <div className="d-flex justify-content-end mb-2">
          <h6 onClick={() => navigate('/forgot-password')} role="button">
            Forgot password?
          </h6>
        </div>

        {isSending ? (
                 <div className="d-flex align-items-center justify-content-center"><div className="spinner-border" role="status"></div></div>
              ) : (<CommonButton title="Login" onClick={handleLogin}/>)}
              {errorMessage && <div className="d-flex align-items-center justify-content-center mt-3"><p style={{ color: 'red' }}>{errorMessage}</p></div>}
      </LoginCard>
    </LoginContainer>
  );
};

export default Login;
